import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The files filed on a picking round — today that is its shipping labels, one PDF per sign-off
 * that booked load carriers. Read through the generic files API, which every member of the
 * organisation reads.
 */
export function useSuborderFiles(suborderId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["suborder-files", suborderId],
		queryFn: async () => {
			const response = await client.files[":tableName"][":key"][":identifier"].$get({
				param: { tableName: "suborderFiles", key: "suborderId", identifier: suborderId },
			});
			const data = await responseHandler(response);
			return data.files;
		},
	});

	/** Return */
	return { ...query, files: query.data ?? [] };
}
